// Ключ идемпотентности. Один на всё приложение: сервер по нему возвращает ранее созданную
// запись вместо второй такой же (contract-first.md, правило 15).
//
// Правило жизни ключа: он живёт столько же, сколько ФОРМА, а не столько, сколько запрос.
// Двойное нажатие и повтор после обрыва обязаны прийти с тем же ключом — иначе у человека
// заведутся два сотрудника с одним паспортом. Новая форма — новый ключ.

export function newIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `bark-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
